import { Navigate, generatePath } from 'react-router';

import { useTypedParams } from '@sorare/routing';

import { NBA_PLAY_CHASE_USERGROUP_USER } from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

import type { PageParams } from './__generated__/routeParams';

const PlayChaseUserGroupPage = () => {
  const { userGroup: userGroupSlug } = useTypedParams<PageParams>();
  const { currentUser } = useCurrentUserContext();

  return (
    <Navigate
      to={generatePath(NBA_PLAY_CHASE_USERGROUP_USER, {
        userGroup: userGroupSlug,
        user: currentUser?.slug ?? '',
      })}
      replace
    />
  );
};

export default PlayChaseUserGroupPage;
